import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { AgGridReact } from '@ag-grid-community/react';
import { defaultGridHeight } from './utils';
import { useCommonVendorsContext } from 'contexts/CategoryInsightsKpi/CommonVendorsProvider';

const CommonVendorsExplore = () => {
	const { gridData } = useCommonVendorsContext();
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of suppliers present in multiple business units.`}
				</AnalysisDescription>
				<TableContainer>
					<div style={gridStyle} className="ag-theme-balham">
						<AgGridReact {...gridData} />
					</div>
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default CommonVendorsExplore;
